var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "award",
      class: "rarity" + _vm.rarity,
      style: { width: _vm.width, height: _vm.width },
    },
    [
      _c("div", { staticClass: "placeholder" }),
      _c("div", { staticClass: "blank-icon" }),
      _c("div", { staticClass: "item-info" }, [
        _c("span", { staticClass: "desc" }, [_vm._v("磨损")]),
        _c("span", { staticClass: "desc" }, [_vm._v("价格")]),
        _c("span", { staticClass: "dur" }, [
          _vm._v(_vm._s(_vm._f("GetItemDuration")(_vm.name))),
        ]),
        _c(
          "span",
          { staticClass: "price" },
          [
            _vm._v(_vm._s(_vm.price) + "  "),
            _c("c-svg", {
              attrs: {
                src: "coin-2159.svg",
                width: "12",
                height: "12",
                fill: "#4762f2",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "itemimg" }, [
        _c("img", { attrs: { src: _vm.$imgfilter(_vm.picture) } }),
      ]),
      _c("c-svg", {
        staticClass: "itembg",
        attrs: { src: "itembg.svg", fill: "rgba(0, 0, 0, 0.2)" },
      }),
      _c("div", { staticClass: "item-name-con" }, [
        _c("div", { staticClass: "item-name" }, [
          _c("div", { staticClass: "weapon-name" }, [
            _vm._v(_vm._s(_vm._f("GetItemName")(_vm.name))),
          ]),
          _c("div", { staticClass: "skin-name" }, [
            _vm._v(_vm._s(_vm._f("GetItemSkinName")(_vm.name))),
          ]),
        ]),
        _c("div", { staticClass: "block" }),
      ]),
      _vm.rate
        ? _c("div", { staticClass: "rate" }, [
            _vm._v(" " + _vm._s(_vm.rate) + " %"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }